export default __webpack_public_path__ + "static/media/Blue marble canvas_primary.90d27079.jpg";